import { createPortal } from 'react-dom';
import { useSearchParams } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '@/Application/Hooks/Redux';
import { PaymentLoader } from '@/modules/perseo-billing/components';
import usePreventPullToRefresh from '@/modules/perseo-billing/hooks/use-prevent-pull-to-refresh';
import { useGetQRValidate } from '@/modules/perseo-billing/hooks/use-qr-modal';
import { EPayStatus } from '@/modules/perseo-billing/interfaces/src/bff-web/billing';
import {
  setCancelOrderChangePaymentMethod,
  setIsModalQRCencopayVisible
} from '@/modules/perseo-billing/store/slices/billing';
import {
  Card,
  Modal
} from '@/modules/perseo-billing/ui/react/src/components/beta';
import { useMediaQuery } from '@/modules/perseo-billing/ui/react/src/ui-hooks';

import { CencoPayModalBody } from './cencopay-qr-modal-body.component';
import { CencoPayModalHeader } from './cencopay-qr-modal-header.component';

import styles from './styles.module.scss';

export enum ECencopayModalOriginCancelType {
  CHANGE_OF_QR_MODAL = 'change-of-qr-modal',
  CHANGE_OF_APP_MODAL = 'change-of-app-modal'
}
export const CencoPayModal = () => {
  const isMobile = useMediaQuery('sm');
  const dispatch = useAppDispatch();
  const billing = useAppSelector((state) => state?.billing);
  const { isModalQRCencopayVisible, isCencoPayTimeOut, cencoPayStatus } =
    billing;
  const [searchParams] = useSearchParams();
  const urlCencopayOrderNumber = searchParams.get('cencopayOrderId');

  const isBlockedView =
    cencoPayStatus &&
    cencoPayStatus !== EPayStatus.CONFIRMED &&
    cencoPayStatus !== EPayStatus.CANCELLED &&
    urlCencopayOrderNumber;

  const { refetch } = useGetQRValidate();

  const closeModal = () => {
    refetch().then(() => {
      dispatch(setIsModalQRCencopayVisible(false));

      if (!isCencoPayTimeOut || cencoPayStatus === EPayStatus.PENDING) {
        dispatch(
          setCancelOrderChangePaymentMethod(
            ECencopayModalOriginCancelType.CHANGE_OF_QR_MODAL
          )
        );
      }
    });
  };

  usePreventPullToRefresh(isModalQRCencopayVisible);

  if (isBlockedView) {
    return <PaymentLoader />;
  }
  const modalContent = (
    <Modal
      open={isModalQRCencopayVisible}
      onClose={closeModal}
      rounded={!isMobile}
      fullWidth
      className={'co-my-auto lg:co-my-auto' + styles.cencopayModal}
      disableEscapeKeyDown
    >
      <Card p={16}>
        <CencoPayModalHeader
          isModalQRCencopayVisible={isModalQRCencopayVisible}
          closeModal={closeModal}
        />
        <CencoPayModalBody closeModal={closeModal} />
      </Card>
    </Modal>
  );

  const modalElement = document.getElementById('modal-cencopay-qr');
  return modalElement ? createPortal(modalContent, modalElement) : null;
};
